import { render, staticRenderFns } from "./TwoRow3.vue?vue&type=template&id=2d942cda"
import script from "./TwoRow3.vue?vue&type=script&lang=js"
export * from "./TwoRow3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports